import React from 'react'

export const Panel = ({ children, className }) => {
  return (
    <div className={`container relative z-20 ${className}`}>
      <div className="max-w-5xl mx-auto bg-white shadow-md xl:max-w-none">
        <div className="max-w-3xl p-8 mx-auto xl:max-w-6xl sm:p-12 md:p-16">
          {children}
        </div>
      </div>
    </div>
  )
}
